export const styles = {
  wrapper: {
    background: '#ffffff',
    border: '1px solid #c5d0de',
    boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.03)',
    borderRadius: '4px',
    marginBottom: '10px',
    padding: '12px 15px',
  },
};
